export const Sizes = {
  fullHeight: 'calc(var(--vh, 1vh) * 100)',
  /**
   * Нужно брать высоту из переменной --vh.
   *
   * https://youtrack.mamba.ru/issue/M-6491
   */
  customFullHeight: 'calc(var(--vh, 1vh) * 100 - env(titlebar-area-height, 0))',
  widthWithoutScrollBar:
    'calc(100vw - var(--scrollbar-width, calc(100vw - 100%)))',
  tablet: 800,
  tabletLarge: 992,
  topBanner: 76,
  smallPhoneHeight: 568,
}
